import React, { useEffect, useState } from "react";

import {
  AttributeContainer,
  BodyContent,
  ContainerItem,
  TextLength,
  TitleContainer,
} from "./style";
import { Switch } from "antd";
import { t } from "i18next";
import PageTitle from "../../shared/pageTitle/PageTitle";
import colors from "../../../theme/colors";
import Label from "../../shared/label/Label";
import ColorPicker from "../../shared/colorPicker/ColorPicker";
import InputColorPicker from "../../shared/inputColorPicker/InputColorPicker";
import { ChannelContext } from "../../../context/channel";
import TextArea from "../../shared/textArea/TextArea";

const Newsletter = () => {
  const dashboardContext = React.useContext(ChannelContext);

  const [callText, setCallText] = useState(dashboardContext.newsletterCall);
  const [shortText, setShortText] = useState(dashboardContext.newsletterText);
  const [newsletter, setNewsletter] = useState<boolean>(
    dashboardContext.newsLetterIsActive
  );


  useEffect(() => {
    dashboardContext.setNewsLetterIsActive(newsletter);
  }, [newsletter]);

  const handleAutoGrow = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    setFunction: React.Dispatch<React.SetStateAction<string>>
  ) => {
    e.target.style.height = `${e.target.scrollHeight}px`;
    setFunction(e.target.value);
  };

  return (
    <BodyContent>
      <div className="space-between">
        <PageTitle>{t('dashboard.newsletter.title')}</PageTitle>
        <Switch
          onChange={() => setNewsletter(!newsletter)}
          checked={newsletter}
          style={{
            backgroundColor: newsletter ? colors.success : colors.border,
          }}
        />
      </div>
      <ContainerItem>
        <TitleContainer>
          <Label style={{ width: "400px" }}>{t('Call')}</Label>
        </TitleContainer>
        <AttributeContainer
          onBlur={() => dashboardContext.setNewsletterCall(callText)}
        >
          <TextArea
            onChange={(e: any) => handleAutoGrow(e, setCallText)}
            value={callText}
            maxLength={100}
            placeholder={t('dashboard.newsletter.call.placeholder')!}
            style={{ marginLeft: "0", maxHeight: "80px", height: "35px" }}
          />
          <TextLength>{`${callText.length} / 100`}</TextLength>
        </AttributeContainer>
      </ContainerItem>
      <ContainerItem>
        <TitleContainer>
          <Label style={{ width: "400px" }}>
            <span>{t('text.short')}</span>
          </Label>
        </TitleContainer>
        <AttributeContainer
          onBlur={() => dashboardContext.setNewsletterText(shortText)}
        >
          <TextArea
            onChange={(e: any) => handleAutoGrow(e, setShortText)}
            value={shortText}
            maxLength={140}
            placeholder={t('dashboard.newsletter.shortText.placeholder')!}
            style={{ minHeight: "60px", maxHeight: "105px" }}
          />
          <TextLength>{`${shortText.length} / 140`}</TextLength>
        </AttributeContainer>
      </ContainerItem>
      <ContainerItem>
        <TitleContainer>
          <Label style={{ width: "400px" }}>{t('dashboard.color.primary')}</Label>
        </TitleContainer>
        <AttributeContainer>
          <InputColorPicker
            color={dashboardContext.newsletterPrimaryColor}
            handleChangeColor={(e) => dashboardContext.setNewsletterPrimaryColor(e.hex)}
          />
        </AttributeContainer>
      </ContainerItem>
      <ContainerItem>
        <TitleContainer>
          <Label style={{ width: "400px" }}>{t('dashboard.color.secondary')}</Label>
        </TitleContainer>
        <AttributeContainer>
          <InputColorPicker
            color={dashboardContext.newsletterSecondaryColor}
            handleChangeColor={(e) => dashboardContext.setNewsletterSecondaryColor(e.hex)}
          />
        </AttributeContainer>
      </ContainerItem>
    </BodyContent>
  );
};

export default Newsletter;
